import { useEffect, useState } from "react";
import ReactDOM from "react-dom";

import style from "./portal.styl";

type PortalProps = {
  children?: React.ReactNode;
  className?: string;
};

const Portal = ({ children, className }: PortalProps) => {
  const [container] = useState(() => window.document.createElement("div"));

  container.classList.add(style.portal);
  if (className) {
    container.classList.add(className);
  }

  useEffect(() => {
    window.document.body.appendChild(container);

    return () => {
      window.document.body.removeChild(container);
    };
  }, [container]);

  return ReactDOM.createPortal(children, container);
};

Portal.displayName = "Portal";

export default Portal;
